import React from 'react';
import { createRoot } from 'react-dom/client';
// typography.css first — before App (whose module graph pulls in the other
// stylesheets) and App.css, so its rules sit earliest in source order.
import './typography.css';
import App from './App';
import './App.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
